import slice from './reducer'

export const {
  checkCaseAndUpdateIfInAgenda,
  addCaseError,
  removeCaseError,

  addMany,
  addOne,
  removeOne,
  updateMany,
  updateOne,
  updateAttributesOnMany,
  updateAttributesOnOne,

  clearCaseReferance,
  setFocusedCaseId,
} = slice.actions

export default slice.reducer
